import { copyTextToClipboard } from "../../utils/copyToClipboard";
import { V3IconCopy } from "../Icons";
import { V3Tooltip } from "../Tooltip";
import { V3CCDisabledInput } from "../V3CopyToClipobard";
import { TopBarWithCopyIconSpacer, TopBarWithCopyWrapper } from "./TopBarInputWithCopy.styles";

interface TopBarInputWithCopyProps {
    url: string,
}

export const TopBarInputWithCopy = ({ url }: TopBarInputWithCopyProps) => {
    const inputText = url.replace("https://", "");

    return <TopBarWithCopyWrapper>
        <div>
            <V3CCDisabledInput
                as="input"
                value={inputText}
                readOnly
                onFocus={(event: any) => {
                    event.target.select();
                    copyTextToClipboard(url);
                }}
            />
        </div>
        <div onClick={() => { copyTextToClipboard(url); }}>
            <V3Tooltip
                referenceContent={<TopBarWithCopyIconSpacer>
                    <V3IconCopy size={18} />
                </TopBarWithCopyIconSpacer>}
                tooltipContent={"Copy URL"}
                placement="right"
            />
        </div>
    </TopBarWithCopyWrapper>
}